import Vue from 'vue'
import Router from 'vue-router'
import store from '../stores/store'

import customTableRouter from '@/plugins/routes/custom_table'
import CmFrotasRouter from '@/plugins/routes/cm-frotas'
import CmTaxasRouter from '@/plugins/routes/cm-taxas'
import CmCronoRouter from '@/plugins/routes/cm-crono'
import CmEmbarcadorRouter from '@/plugins/routes/cm-embarcador'
import DriverIndicationRouter from '@/plugins/routes/driver-indication'

import adminMaestroRouter from '@/plugins/routes/admin/maestro'
import adminDocHubRouter from '@/plugins/routes/admin/doc_hub'

import adminCityHallMapper from '@/plugins/routes/admin/city_hall_mapper'
import adminPayloadRouter from '@/plugins/routes/admin/payload'
import adminOrder from '@/plugins/routes/admin/order'
import adminOrderEmbarcador from '@/plugins/routes/admin/order_embarcador'
import adminItem from '@/plugins/routes/admin/item'

//** Application */
const Account = () => import(/* webpackChunkName: "application" */ '@/components/Account')
const Dashboard = () => import(/* webpackChunkName: "application" */ '../components/Dashboard')
const DashboardIndex = () => import(/* webpackChunkName: "application" */ '../components/dashboard/Index')
const DashboardGeneral = () => import(/* webpackChunkName: "application" */ '../components/dashboard/General')
const DashboardDfe = () => import(/* webpackChunkName: "application" */ '../components/dashboard/DashboardDfe')
const DashboardCMFrotas = () => import(/* webpackChunkName: "application" */ '../components/dashboard/DashboardCMFrotas')
const DashboardCMTaxas = () => import(/* webpackChunkName: "application" */ '../components/dashboard/DashboardCMTaxas')
const DashboardCMCrono = () => import(/* webpackChunkName: "application" */ '../components/dashboard/DashboardCMCrono')
const DashboardCMEmbarcador = () => import(/* webpackChunkName: "application" */ '../components/dashboard/DashboardCMEmbarcador')

//**  Admin */
const Admin = () => import(/* webpackChunkName: "admin" */ '@/components/Admin')
const AdminCalendar = () => import(/* webpackChunkName: "admin" */ '@/components/admin/Calendar')
const Associate = () => import(/* webpackChunkName: "admin" */ '@/components/admin/Associate')
const AssociateIndex = () => import(/* webpackChunkName: "admin" */ '@/components/admin/associates/Index')
const AssociateNew = () => import(/* webpackChunkName: "admin" */ '@/components/admin/associates/New')
const AssociateShow = () => import(/* webpackChunkName: "admin" */ '@/components/admin/associates/Show')
const AdminIndex = () => import(/* webpackChunkName: "admin" */ '@/components/admin/Index')
const AdminEvent = () => import(/* webpackChunkName: "admin" */ '@/components/admin/Events')
const AdminEmailTemplates = () => import(/* webpackChunkName: "admin" */ '@/components/admin/EmailTemplates')
const AdminApp = () => import(/* webpackChunkName: "admin" */ '@/components/admin/App')
const AdminUser = () => import(/* webpackChunkName: "admin" */ '@/components/admin/users')
const AdminUserShow = () => import(/* webpackChunkName: "admin" */ '@/components/admin/users/show')

const AdminAccounts = () => import(/* webpackChunkName: "admin" */ '@/components/admin/Accounts')
const AdminAccountsShow = () => import(/* webpackChunkName: "admin" */ '@/components/admin/accounts/Show')
const AdminAccountsIndex = () => import(/* webpackChunkName: "admin" */ '@/components/admin/accounts/Index')
const AdminPartnerAccounts = () => import(/* webpackChunkName: "admin" */ '@/components/admin/accounts/PartnerAccount')

const AdminCompanies = () => import(/* webpackChunkName: "admin" */ '@/components/admin/Companies')
const AdminCompaniesIndex = () => import(/* webpackChunkName: "admin" */ '@/components/admin/companies/Index')

const AdminDrivers = () => import(/* webpackChunkName: "admin" */ '@/components/admin/Drivers')
const AdminDriversIndex = () => import(/* webpackChunkName: "admin" */ '@/components/admin/drivers/index')

const AdminCredentials = () => import(/* webpackChunkName: "admin" */ '@/components/admin/credentials/index')

const AdminVehicles = () => import(/* webpackChunkName: "admin" */ '@/components/admin/vehicles/index')

const AdminAppsIndex = () => import(/* webpackChunkName: "admin" */ '@/components/admin/apps/Index')
const AdminAppsShow = () => import(/* webpackChunkName: "admin" */ '@/components/admin/apps/Show')

const AdminTemplateService = () => import(/* webpackChunkName: "admin" */ '@/components/admin/TemplateService')
const AdminTemplateServicesIndex = () => import(/* webpackChunkName: "admin" */ '@/components/admin/template_services/Index')

const AdminFeatureFlagsIndex = () => import(/* webpackChunkName: "admin" */ '@/components/admin/feature_flags/index')
const AdminFeatureFlagsShow = () => import(/* webpackChunkName: "admin" */ '@/components/admin/feature_flags/show')

const AdminEntityStatusesIndex = () => import(/* webpackChunkName: "admin" */ '@/components/admin/entity_statuses/Index')

const AdminCounter = () => import(/* webpackChunkName: "admin" */ '@/components/admin/Counter')
const AdminCounterIndex = () => import(/* webpackChunkName: "admin" */ '@/components/admin/counter/Index')

const AdminReport = () => import(/* webpackChunkName: "admin" */ '@/components/admin/Report')
const AdminReportIndex = () => import(/* webpackChunkName: "admin" */ '@/components/admin/reports/Index')
const AdminReportDFe = () => import(/* webpackChunkName: "admin" */ '@/components/admin/reports/DFe')

const CustomTable = () => import(/* webpackChunkName: "admin" */ '@/components/admin/CustomTable')
const CustomTableIndex = () => import(/* webpackChunkName: "admin" */ '@/components/admin/custom_tables/Index')
const CustomTableNew = () => import(/* webpackChunkName: "admin" */ '@/components/admin/custom_tables/New')
const CustomTableShow = () => import(/* webpackChunkName: "admin" */ '@/components/admin/custom_tables/Show')
const CustomTableWork = () => import(/* webpackChunkName: "admin" */ '@/components/admin/custom_tables/Work')
const Document = () => import(/* webpackChunkName: "admin" */ '@/components/admin/Document')
const Email = () => import(/* webpackChunkName: "admin" */ '@/components/admin/Email')
const AdminFinanceiro = () => import(/* webpackChunkName: "admin" */ '@/components/admin/Financeiro')
const AdminFinanceiroIndex = () => import(/* webpackChunkName: "admin" */ '@/components/admin/financeiro/Index')
const Models = () => import(/* webpackChunkName: "admin" */ '@/components/admin/Models')
const Notification = () => import(/* webpackChunkName: "admin" */ '@/components/admin/Notification')
const NotificationTemplate = () => import(/* webpackChunkName: "admin" */ '@/components/admin/NotificationTemplate')
const Observer = () => import(/* webpackChunkName: "admin" */ '@/components/admin/Observer')
const SqsMessage = () => import(/* webpackChunkName: "admin" */ '@/components/admin/SqsMessages')
const AdminNsuManager = () => import(/* webpackChunkName: "admin" */ '@/components/admin/NsuManager')

const AdminDocumentationItems = () => import(/* webpackChunkName: "admin" */ '@/components/admin/DocumentationItems')

const EventSchedule = () => import(/* webpackChunkName: "admin_schedule" */ '@/components/admin/EventSchedule')
const EventScheduleIndex = () => import(/* webpackChunkName: "admin_schedule" */ '@/components/admin/event_schedule/Index')
const AdminVolumetria = () => import(/* webpackChunkName: "admin_volumetria" */ '@/components/admin/volumetria/Index')

//** AdminUnicoIntegration */
const AdminUnicoIntegration = () => import(/* webpackChunkName: "unico_integration" */ '@/components/admin/UnicoIntegration')
const AdminUnicoIntegrationIndex = () => import(/* webpackChunkName: "unico_integration" */ '@/components/admin/unico_integration/Index')
const AdminUnicoIntegrationEvent = () => import(/* webpackChunkName: "unico_integration" */ '@/components/admin/unico_integration/Event')
const AdminUnicoIntegrationLogin = () => import(/* webpackChunkName: "unico_integration" */ '@/components/admin/unico_integration/Login')

//** Apps */
const AppsMarketplace = () => import(/* webpackChunkName: "apps" */ '../components/Apps')
const IndexApps = () => import(/* webpackChunkName: "apps" */ '@/components/apps/Index')
const ShowApp = () => import(/* webpackChunkName: "apps" */ '@/components/apps/Show')

//** Calendar */
const Calendar = () => import(/* webpackChunkName: "calendar" */ '../components/Calendar')
const Definitions = () => import(/* webpackChunkName: "definition" */ '../components/Definitions')

//** DFe */
import { dfeRoutes, nfseNacionalRoute } from './routes/dfe'
const OldDownload = () => import(/* webpackChunkName: "dfe" */ '@/components/dfe/OldDownload')

//** Login */
const Login = () => import(/* webpackChunkName: "login" */ '../components/auth/Login')
const ForgotPassword = () => import(/* webpackChunkName: "login" */ '@/components/auth/ForgotPassword')
const ResetPassword = () => import(/* webpackChunkName: "login" */ '@/components/auth/ResetPassword')
const RegisterPassword = () => import(/* webpackChunkName: "login" */ '@/components/auth/RegisterPassword')

//** Status */
const Status = () => import(/* webpackChunkName: "login" */ '@/components/Status')
const ApiDocs = () => import(/* webpackChunkName: "others" */ '@/components/ApiDocs')

//** UnicoIntegration **//
const UnicoIntegration = () => import(/* webpackChunkName: "unicoIntegration" */'@/components/UnicoIntegration')
const UnicoIntegrationIndex = () => import(/* webpackChunkName: "unicoIntegration" */'@/components/unico_integration/Index')
const UnicoIntegrationSetting = () => import(/* webpackChunkName: "unicoIntegration" */'@/components/unico_integration/Setting')
const UnicoIntegrationSettingIndex = () => import(/* webpackChunkName: "unicoIntegration" */'@/components/unico_integration/settings/Index')
const UnicoIntegrationSettingForm = () => import(/* webpackChunkName: "unicoIntegration" */'@/components/unico_integration/settings/Form')
const UnicoIntegrationFiscalDocumentEvent = () => import(/* webpackChunkName: "unicoIntegration" */'@/components/unico_integration/FiscalDocumentEvent')

//** others */
const ErrorNetwork = () => import(/* webpackChunkName: "others" */ '../components/shares/ErrorNetwork')
const Wizard = () => import(/* webpackChunkName: "others" */ '../components/Wizard')
const NotFound = () => import(/* webpackChunkName: "others" */ '../components/shares/NotFound')
const StyleGuide = () => import(/* webpackChunkName: "others" */ '../components/StyleGuide')

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      children: [
        {
          component: Account,
          path: '/accounts'
        },
        {
          children: [
            {
              alias: '/dashboard',
              component: DashboardGeneral,
              path: '/',
            },
            {
              component: DashboardDfe,
              path: '/dashboard/dfe',
            },
            {
              component: DashboardCMFrotas,
              path: '/dashboard/cm-frotas',
            },
            {
              component: DashboardCMTaxas,
              path: '/dashboard/cm-taxas',
            },
            {
              component: DashboardCMEmbarcador,
              path: '/dashboard/cm-embarcador',
            },
            {
              component: DashboardCMCrono,
              path: '/dashboard/cm-crono',
            }
          ],
          component: DashboardIndex,
          path: '/'
        },
        dfeRoutes,
        nfseNacionalRoute,
        {
          children: [
            {
              component: IndexApps,
              meta: {
                breadcrumbs: [{ name: 'Apps e Marketplace' }]
              },
              path: '/',
            },
            {
              component: ShowApp,
              meta: {
                breadcrumbs: [
                  { link: '/apps', name: 'Apps e Marketplace' },
                  { dynamicName: () => store.getters.getNameBreadcrumb, name: 'Show' },
                ]
              },
              path: ':name'
            }
          ],
          component: AppsMarketplace,
          path: 'apps'
        },
        {
          component: Calendar,
          name: 'calendar',
          path: 'calendar',
        },
        {
          component: Definitions,
          name: 'definitions',
          path: 'definitions'
        },
        {
          children: [
            {
              component: AdminIndex,
              meta: {
                breadcrumbs: [
                  { name: 'Administração' },
                ]
              },
              path: '/'
            },
            {
              children: [
                {
                  component: AdminAccountsIndex,
                  meta: {
                    breadcrumbs: [
                      { link: '/admin', name: 'Administração' },
                      { name: 'Accounts' },
                    ]
                  },
                  path: '/'
                },
                {
                  component: AdminAccountsShow,
                  meta: {
                    breadcrumbs: [
                      { link: '/admin', name: 'Administração' },
                      { link: '/admin/accounts', name: 'Account' },
                      { dynamicName: () => store.getters.getNameBreadcrumb, name: 'Show' },
                    ]
                  },
                  path: ':id',
                  props: true
                }
              ],
              component: AdminAccounts,
              path: 'accounts'
            },
            {
              children: [
                {
                  component: AssociateIndex,
                  meta: {
                    breadcrumbs: [
                      { link: '/admin', name: 'Administração' },
                      { name: 'Associados' },
                    ]
                  },
                  path: '/'
                },
                {
                  component: AssociateNew,
                  meta: {
                    breadcrumbs: [
                      { link: '/admin', name: 'Administração' },
                      { link: '/admin/associates', name: 'Associados' },
                      { name: 'Novo' }
                    ]
                  },
                  path: 'new'
                },
                {
                  component: AssociateShow,
                  meta: {
                    breadcrumbs: [
                      { link: '/admin', name: 'Administração' },
                      { link: '/admin/associates', name: 'Associados' },
                      { dynamicName: () => store.getters.getNameBreadcrumb, name: 'Show' },
                    ]
                  },
                  path: ':id',
                  props: true
                }
              ],
              component: Associate,
              path: 'associates'
            },
            {
              children: [
                {
                  component: CustomTableIndex,
                  meta: {
                    breadcrumbs: [
                      { link: '/admin', name: 'Administração' },
                      { name: 'CustomTable' },
                    ]
                  },
                  path: '/'
                },
                {
                  component: CustomTableNew,
                  meta: {
                    breadcrumbs: [
                      { link: '/admin', name: 'Administração' },
                      { link: '/admin/custom_tables', name: 'CustomTable' },
                      { name: 'Novo' }
                    ]
                  },
                  path: 'new'
                },
                {
                  component: CustomTableShow,
                  meta: {
                    breadcrumbs: [
                      { link: '/admin', name: 'Administração' },
                      { link: '/admin/custom_tables', name: 'CustomTable' },
                      { dynamicName: () => store.getters.getNameBreadcrumb, name: 'Show' },
                    ]
                  },
                  path: ':id',
                  props: true
                },
                {
                  component: CustomTableWork,
                  meta: {
                    breadcrumbs: [
                      { link: '/admin', name: 'Administração' },
                      { link: '/admin/custom_tables', name: 'CustomTable' },
                      { dynamicName: () => store.getters.getNameBreadcrumb, name: 'Work' },
                    ]
                  },
                  path: ':id/work',
                  props: true
                }
              ],
              component: CustomTable,
              path: 'custom_tables'
            },
            {
              component: AdminCalendar,
              meta: {
                breadcrumbs: [
                  { link: '/admin', name: 'Administração' },
                  { name: 'Calendários' },
                ]
              },
              path: 'calendars'
            },
            {
              children: [
                {
                  component: AdminCounterIndex,
                  meta: {
                    breadcrumbs: [
                      { link: '/admin', name: 'Administração' },
                      { name: 'Contador' },
                    ]
                  },
                  path: '/'
                }
              ],
              component: AdminCounter,
              path: 'counters'
            },
            {
              children: [
                {
                  component: AdminReportIndex,
                  meta: {
                    breadcrumbs: [
                      { link: '/admin', name: 'Administração' },
                      { name: 'Relatórios' },
                    ]
                  },
                  path: '/'
                },
                {
                  component: AdminReportDFe,
                  meta: {
                    breadcrumbs: [
                      { link: '/admin', name: 'Administração' },
                      { link: '/admin/reports', name: 'Relatórios' },
                      { name: 'DFe' },
                    ]
                  },
                  path: 'dfe'
                },
              ],
              component: AdminReport,
              path: 'reports'
            },
            {
              component: Email,
              meta: {
                breadcrumbs: [
                  { link: '/admin', name: 'Administração' },
                  { name: 'E-mails' },
                ]
              },
              path: 'emails'
            },
            {
              component: AdminEmailTemplates,
              meta: {
                breadcrumbs: [
                  { link: '/admin', name: 'Administração' },
                  { name: 'Templates de E-mail' },
                ]
              },
              path: 'email_templates'
            },
            {
              component: AdminEvent,
              meta: {
                breadcrumbs: [
                  { link: '/admin', name: 'Administração' },
                  { name: 'Eventos' },
                ]
              },
              path: 'events'
            },
            {
              component: Document,
              meta: {
                breadcrumbs: [
                  { link: '/admin', name: 'Administração' },
                  { name: 'Documentos' },
                ]
              },
              path: 'documents'
            },
            {
              children: [
                {
                  component: AdminAppsIndex,
                  meta: {
                    breadcrumbs: [
                      { link: '/admin', name: 'Administração' },
                      { name: 'Apps' },
                    ]
                  },
                  path: '/'
                },
                {
                  component: AdminAppsShow,
                  meta: {
                    breadcrumbs: [
                      { link: '/admin', name: 'Administração' },
                      { link: '/admin/apps', name: 'Apps' },
                      { dynamicName: () => store.getters.getNameBreadcrumb, name: 'Show' },
                    ]
                  },
                  path: ':id/edit',
                  props: true
                }
              ],
              component: AdminApp,
              path: 'apps'
            },
            {
              children: [
                {
                  component: AdminTemplateServicesIndex,
                  meta: {
                    breadcrumbs: [
                      { link: '/admin', name: 'Administração' },
                      { name: 'Serviços de Template (Template Services)' },
                    ]
                  },
                  path: '/'
                }
              ],
              component: AdminTemplateService,
              path: 'template_services'
            },
            {
              component: AdminFeatureFlagsIndex,
              meta: {
                breadcrumbs: [
                  { link: '/admin', name: 'Administração' },
                  { name: 'Feature Flags' },
                ]
              },
              path: 'feature_flags'
            },
            {
              component: AdminEntityStatusesIndex,
              meta: {
                breadcrumbs: [
                  { link: '/admin', name: 'Administração' },
                  { name: 'Entity Statuses' },
                ]
              },
              path: 'entity_statuses'
            },
            {
              component: AdminFeatureFlagsShow,
              meta: {
                breadcrumbs: [
                  { link: '/admin', name: 'Administração' },
                  { link: '/admin/feature_flags', name: 'Feature Flags' },
                  { dynamicName: () => store.getters.getNameBreadcrumb, name: 'Contas' },
                ]
              },
              path: 'feature_flags/:id',
              props: true
            },
            {
              component: Notification,
              meta: {
                breadcrumbs: [
                  { link: '/admin', name: 'Administração' },
                  { name: 'Notificações' },
                ]
              },
              path: 'notifications'
            },
            {
              component: NotificationTemplate,
              meta: {
                breadcrumbs: [
                  { link: '/admin', name: 'Administração' },
                  { name: 'Notificações automáticas' },
                ]
              },
              path: 'notification-templates'
            },
            {
              component: Observer,
              meta: {
                breadcrumbs: [
                  { link: '/admin', name: 'Administração' },
                  { name: 'Observadores' },
                ]
              },
              path: 'observers'
            },
            {
              component: AdminUser,
              meta: {
                breadcrumbs: [
                  { link: '/admin', name: 'Administração' },
                  { name: 'Usuários' },
                ]
              },
              path: 'users'
            },
            {
              component: AdminUserShow,
              meta: {
                breadcrumbs: [
                  { link: '/admin', name: 'Administração' },
                  { link: '/admin/users', name: 'Usuários' },
                  { dynamicName: () => store.getters.getNameBreadcrumb },
                ]
              },
              path: 'users/:id'
            },
            {
              children: [
                {
                  component: AdminCompaniesIndex,
                  meta: {
                    breadcrumbs: [
                      { link: '/admin', name: 'Administração' },
                      { name: 'Empresas' },
                    ]
                  },
                  path: '/'
                }
              ],
              component: AdminCompanies,
              path: 'companies'
            },
            {
              children: [
                {
                  component: AdminFinanceiroIndex,
                  meta: {
                    breadcrumbs: [
                      { link: '/admin', name: 'Administração' },
                      { name: 'Financeiro' },
                    ]
                  },
                  path: '/'
                }
              ],
              component: AdminFinanceiro,
              path: 'financeiro'
            },
            {
              children: [
                {
                  component: AdminDriversIndex,
                  meta: {
                    breadcrumbs: [
                      { link: '/admin', name: 'Administração' },
                      { name: 'Motoristas' },
                    ]
                  },
                  path: '/'
                }
              ],
              component: AdminDrivers,
              path: 'drivers'
            },
            {
              component: AdminCredentials,
              meta: {
                breadcrumbs: [
                  { link: '/admin', name: 'Administração' },
                  { name: 'Credenciais' },
                ]
              },
              path: 'credentials'
            },
            {
              component: AdminVehicles,
              meta: {
                breadcrumbs: [
                  { link: '/admin', name: 'Administração' },
                  { name: 'Veículos' },
                ]
              },
              path: 'vehicles'
            },
            {
              component: Models,
              meta: {
                breadcrumbs: [
                  { link: '/admin', name: 'Administração' },
                  { name: 'Models' },
                ]
              },
              path: 'models'
            },
            {
              component: SqsMessage,
              meta: {
                breadcrumbs: [
                  { link: '/admin', name: 'Administração' },
                  { name: 'SQS Messages' },
                ]
              },
              path: 'sqs_messages'
            },
            {
              component: AdminNsuManager,
              meta: {
                breadcrumbs: [
                  { link: '/admin', name: 'Administração' },
                  { name: 'NSU Distribuição' },
                ]
              },
              path: 'nsu_distributions'
            },
            {
              component: AdminDocumentationItems,
              meta: {
                breadcrumbs: [
                  { link: '/admin', name: 'Administração' },
                  { name: 'Documentation Items' },
                ]
              },
              path: 'documentation_items'
            },
            {
              component: EventSchedule,
              children: [
                {
                  component: EventScheduleIndex,
                  meta: {
                    breadcrumbs: [
                      { link: '/admin', name: 'Administração' },
                      { name: 'Agendamentos' },
                    ]
                  },
                  path: '/',
                }
              ],
              meta: {
                breadcrumbs: [
                  { link: '/admin', name: 'Administração' },
                  { name: 'Agendamentos' },
                ]
              },
              path: 'event_schedules'
            },
            {
              component: AdminVolumetria,
              meta: {
                breadcrumbs: [
                  { link: '/admin', name: 'Administração' },
                  { name: 'Volumetria de Consultas' },
                ]
              },
              path: 'volumetria'
            },
            {
              component: AdminPartnerAccounts,
              meta: {
                breadcrumbs: [
                  { link: '/admin', name: 'Administração' },
                  { link: '/admin/accounts', name: 'Accounts' },
                  { dynamicName: () => store.getters.getNameBreadcrumb },
                ]
              },
              path: 'partner_accounts/:id',
              props: true
            },
            adminCityHallMapper,
            adminPayloadRouter,
            adminMaestroRouter,
            adminDocHubRouter,
            // Removido: adminScheduleRouter,
            adminOrder,
            adminOrderEmbarcador,
            adminItem,
            {
              children: [
                {
                  component: AdminUnicoIntegrationIndex,
                  meta: {
                    breadcrumbs: [
                      { link: '/admin', name: 'Administração' },
                      { name: 'UnicoIntegration' },
                    ]
                  },
                  path: '/',
                },
                {
                  component: AdminUnicoIntegrationEvent,
                  meta: {
                    breadcrumbs: [
                      { link: '/admin', name: 'Administração' },
                      { link: '/admin/unico_integration', name: 'UnicoIntegration' },
                      { name: 'Eventos' },
                    ]
                  },
                  path: 'events',
                },
                {
                  component: AdminUnicoIntegrationLogin,
                  meta: {
                    breadcrumbs: [
                      { link: '/admin', name: 'Administração' },
                      { link: '/admin/unico_integration', name: 'UnicoIntegration' },
                      { name: 'Logins' },
                    ]
                  },
                  path: 'logins',
                },
              ],
              component: AdminUnicoIntegration,
              meta: {
                breadcrumbs: [
                  { link: '/admin', name: 'Administração' },
                  { name: 'UnicoIntegration' },
                ]
              },
              path: 'unico_integration'
            },
          ],
          component: Admin,
          path: 'admin'
        },
        {
          component: OldDownload,
          path: '/dfe/batch_report/*'
        },
        {
          component: OldDownload,
          path: '/sefaz/batch_manifest_dfes/*'
        },
        {
          children: [
            {
              component: UnicoIntegrationIndex,
              meta: {
                breadcrumbs: [{ name: 'Unico Integration' }]
              },
              path: '/'
            },
            {
              children: [
                {
                  component: UnicoIntegrationSettingIndex,
                  meta: {
                    breadcrumbs: [
                      { link: '/unico_integration', name: 'Unico Integration' },
                      { name: 'Configurações' },
                    ]
                  },
                  path: '/',
                },
                {
                  component: UnicoIntegrationSettingForm,
                  meta: {
                    breadcrumbs: [
                      { link: '/unico_integration', name: 'Unico Integration' },
                      { link: '/unico_integration/settings', name: 'Configurações' },
                      { dynamicName: () => store.getters.getNameBreadcrumb, name: 'Show' },
                    ]
                  },
                  path: ':id',
                  props: true
                },
              ],
              component: UnicoIntegrationSetting,
              path: 'settings',
            },
            {
              component: UnicoIntegrationFiscalDocumentEvent,
              meta: {
                breadcrumbs: [
                  { link: '/unico_integration', name: 'Unico Integration' },
                  { name: 'Eventos' }
                ]
              },
              path: 'fiscal_document_events'
            }
          ],
          component: UnicoIntegration,
          path: 'unico_integration'
        },
        customTableRouter,
        CmFrotasRouter,
        CmTaxasRouter,
        CmCronoRouter,
        CmEmbarcadorRouter,
        DriverIndicationRouter,
      ],
      component: Dashboard,
      path: '/'
    },
    {
      component: Status,
      path: '/status'
    },
    {
      component: ApiDocs,
      name: 'api-docs',
      path: '/api-docs'
    },
    {
      component: Wizard,
      path: '/wizard'
    },
    {
      beforeEnter: (to, from, next) => {
        store.state.user = null
        next()
      },
      component: ErrorNetwork,
      name: 'errorNetwork',
      path: '/error-network'
    },
    {
      component: Login,
      name: 'login',
      path: '/login',
    },
    {
      component: ForgotPassword,
      path: '/forgot_password'
    },
    {
      component: ResetPassword,
      path: '/reset_password'
    },
    {
      component: RegisterPassword,
      path: '/register_password'
    },
    {
      component: StyleGuide,
      name: 'styleguide',
      path: '/styleguide'
    },
    {
      component: NotFound,
      path: '*'
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (window.performance && window.performance.navigation.type === 2) {
    if (window.history.state) {
      window.history.replaceState({ ...window.history.state, back: true }, '', to.fullPath)
    } else {
      window.history.replaceState({ back: true }, '', to.fullPath)
    }
  }
  next()
})

export default router
